<template>
  <div class="prize-page background-image">

    <wd-img class="prize-page-title ma-xxl mb-0" :src="mayPrizeTitle"/>
    <template v-for="exchangeDetail in exchangeDetailList">
      <div class="prize-item bg-white ma-lg pa-lg round-10">
        <div class="text-bold">{{ exchangeDetail.prizeName }}</div>
        <wd-row flex justify="space-between" class="mt-md text-red">
          <wd-col span="16">
            <span style="font-size: 12px;">领奖时间：{{ exchangeDetail.createTime }}</span>
          </wd-col>
          <wd-col span="8">
            <span class="prize-item-btn bg-primary-deep" style="font-size: 12px;float: right" @click="toHelp">使用指南</span>
          </wd-col>
        </wd-row>
        <wd-row flex justify="space-between" class="mt-md text-red">
          <wd-col span="16" style="font-size: 12px">
            兑换码：<span id="copy_text">{{ exchangeDetail.code }}</span>
          </wd-col>
          <wd-col span="8">
            <span class="prize-item-btn bg-primary-deep copy" style="font-size: 12px;float: right"  @click="copyUrl" data-clipboard-target="#copy_text">复制兑换码</span>
          </wd-col>
        </wd-row>
      </div>
    </template>
  </div>
</template>

<script>
import {getExchangeDetailList} from "@/api/tianyi/tianyi.api";
import Clipboard from "clipboard";
import {mayPrizeTitle} from "@/skin/skin";

export default {
  name: "PrizePage",
  data() {
    return {
      mayPrizeTitle: mayPrizeTitle,
      exchangeDetailList: [],
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      getExchangeDetailList(this.$store.getters["User/user"].appUser.token).then(resp => {
        if (resp.code === 0) {
          this.exchangeDetailList = resp.data
        }
      })
    },
    toHelp(){
      this.$router.push("/help")
    },
    copyUrl(){
      const _this = this
      let clipboard = new Clipboard(".copy");
      clipboard.on("success", function(e) {
        _this.$toast('复制成功')
        clipboard.destroy();
      });
      clipboard.on("error", function(e) {
        _this.$toast.warning('不支持复制')
        clipboard.destroy();
      });
    }
  }
}
</script>

<style lang="scss">
.prize-page {
  height: 100%;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
  -o-background-size:100% 100%;

  .prize-item-btn {
    color: white;
    border-radius: 16px;
    padding: 2px 14px;
  }
}
</style>
